import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';
import '../../../neetjee_guru/components/Calendar/_calendar.scss';

// ─── Static mock data ─────────────────────────────────────────────────────────
const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const MONTHS_SHORT = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

const STUDENT_TIMETABLE = {
  0: [],
  1: [
    { id: 'mon1', t: '08:30', end: '09:25', subject: 'Linear Algebra', teacher: 'Prof. N. Iyer', room: 'B-204', code: 'MA-201' },
    { id: 'mb1', break: true, t: '09:25', end: '09:30', title: 'Short Break' },
    { id: 'mon2', t: '09:30', end: '10:25', subject: 'Data Structures', teacher: 'Dr. K. Rao', room: 'Lab-3', code: 'CS-202' },
    { id: 'mb2', break: true, t: '10:25', end: '10:45', title: 'Short Break' },
    { id: 'mon3', t: '10:45', end: '11:40', subject: 'Discrete Mathematics', teacher: 'Prof. S. Mehta', room: 'B-110', code: 'MA-203' },
    { id: 'mon4', t: '11:45', end: '12:40', subject: 'Technical Writing', teacher: 'Ms. A. Fernandes', room: 'A-301', code: 'EN-101' },
    { id: 'mlunch', break: true, t: '12:40', end: '13:30', title: 'Lunch Break' },
    { id: 'mon5', t: '13:30', end: '15:25', subject: 'Physics Laboratory', teacher: 'Dr. V. Joshi', room: 'Lab-1', code: 'PH-202' },
  ],
  2: [
    { id: 'tue1', t: '08:30', end: '09:25', subject: 'Probability Theory', teacher: 'Prof. N. Iyer', room: 'B-204', code: 'MA-204' },
    { id: 'tue2', t: '09:30', end: '10:25', subject: 'Operating Systems', teacher: 'Dr. P. Khanna', room: 'B-115', code: 'CS-301' },
    { id: 'tb1', break: true, t: '10:25', end: '10:45', title: 'Short Break' },
    { id: 'tue3', t: '10:45', end: '11:40', subject: 'Algorithms', teacher: 'Dr. K. Rao', room: 'B-220', code: 'CS-303' },
    { id: 'tue4', t: '11:45', end: '12:40', subject: 'Economics', teacher: 'Prof. M. Dutta', room: 'A-204', code: 'HU-101' },
    { id: 'tlunch', break: true, t: '12:40', end: '13:30', title: 'Lunch Break' },
    { id: 'tue5', t: '13:30', end: '15:25', subject: 'Programming Lab', teacher: 'Dr. P. Khanna', room: 'Lab-2', code: 'CS-301L' },
  ],
  3: [
    { id: 'wed1', t: '08:30', end: '09:25', subject: 'Linear Algebra', teacher: 'Prof. N. Iyer', room: 'B-204', code: 'MA-201' },
    { id: 'wed2', t: '09:30', end: '10:25', subject: 'Algorithms', teacher: 'Dr. K. Rao', room: 'B-220', code: 'CS-303' },
    { id: 'wb1', break: true, t: '10:25', end: '10:45', title: 'Short Break' },
    { id: 'wed3', t: '10:45', end: '11:40', subject: 'Database Systems', teacher: 'Prof. R. Singh', room: 'B-118', code: 'CS-304' },
    { id: 'wed4', t: '11:45', end: '12:40', subject: 'Discrete Mathematics', teacher: 'Prof. S. Mehta', room: 'B-110', code: 'MA-203' },
    { id: 'wlunch', break: true, t: '12:40', end: '13:30', title: 'Lunch Break' },
    { id: 'wed5', t: '13:30', end: '15:25', subject: 'DBMS Lab', teacher: 'Prof. R. Singh', room: 'Lab-4', code: 'CS-304L' },
  ],
  4: [
    { id: 'thu1', t: '08:30', end: '09:25', subject: 'Operating Systems', teacher: 'Dr. P. Khanna', room: 'B-115', code: 'CS-301' },
    { id: 'thu2', t: '09:30', end: '10:25', subject: 'Probability Theory', teacher: 'Prof. N. Iyer', room: 'B-204', code: 'MA-204' },
    { id: 'thb1', break: true, t: '10:25', end: '10:45', title: 'Short Break' },
    { id: 'thu3', t: '10:45', end: '11:40', subject: 'Database Systems', teacher: 'Prof. R. Singh', room: 'B-118', code: 'CS-304' },
    { id: 'thu4', t: '11:45', end: '12:40', subject: 'Technical Writing', teacher: 'Ms. A. Fernandes', room: 'A-301', code: 'EN-101' },
    { id: 'thlunch', break: true, t: '12:40', end: '13:30', title: 'Lunch Break' },
    { id: 'thu5', t: '13:30', end: '14:25', subject: 'Mentor Hour', teacher: 'Class Mentor', room: 'A-101', code: '—' },
    { id: 'thu6', t: '14:30', end: '15:25', subject: 'Self Study', teacher: 'Independent', room: 'Library', code: '—' },
  ],
  5: [
    { id: 'fri1', t: '08:30', end: '09:25', subject: 'Algorithms', teacher: 'Dr. K. Rao', room: 'B-220', code: 'CS-303' },
    { id: 'fri2', t: '09:30', end: '10:25', subject: 'Economics', teacher: 'Prof. M. Dutta', room: 'A-204', code: 'HU-101' },
    { id: 'fb1', break: true, t: '10:25', end: '10:45', title: 'Short Break' },
    { id: 'fri3', t: '10:45', end: '12:40', subject: 'Project Workshop', teacher: 'Dr. K. Rao + Team', room: 'Lab-5', code: 'CS-399' },
    { id: 'flunch', break: true, t: '12:40', end: '13:30', title: 'Lunch Break' },
    { id: 'fri4', t: '13:30', end: '15:25', subject: 'Sports / Clubs', teacher: 'Open', room: 'Grounds', code: '—' },
  ],
  6: [
    { id: 'sat1', t: '08:30', end: '09:25', subject: 'Tutorial', teacher: 'Prof. N. Iyer', room: 'B-204', code: 'MA-201T' },
    { id: 'sat2', t: '09:30', end: '10:25', subject: 'Tutorial', teacher: 'Prof. S. Mehta', room: 'B-205', code: 'MA-201T' },
    { id: 'sb1', break: true, t: '10:25', end: '10:45', title: 'Short Break' },
    { id: 'sat3', t: '10:45', end: '11:40', subject: 'Make-up Class', teacher: 'Open slot', room: 'B-204', code: '—' },
  ],
};

const DATE_META = {
  '2026-5-15': { type: 'holiday', title: 'State Holiday', note: 'No classes' },
  '2026-5-20': { type: 'exam', title: 'Mid-Term Exams', note: 'Block A & B' },
  '2026-5-25': { type: 'event', title: 'Annual Sports Day', note: 'All-day event' },
  '2026-6-1':  { type: 'holiday', title: 'Foundation Day', note: 'College holiday' },
  '2026-6-15': { type: 'exam', title: 'End-Sem Exams', note: 'All departments' },
};

// Mock student attendance for current month (1=present, 0=absent, -1=holiday/no class)
function generateMockAttendance(month, year) {
  const att = {};
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  for (let d = 1; d <= daysInMonth; d++) {
    const date = new Date(year, month, d);
    const dow = date.getDay();
    const k = `${year}-${month + 1}-${d}`;
    if (dow === 0 || DATE_META[k]) { att[d] = -1; continue; }
    att[d] = Math.random() > 0.15 ? 1 : 0;
  }
  return att;
}

// ─── Helpers ──────────────────────────────────────────────────────────────────
function metaKey(d) { return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`; }
function isSameDay(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}
function classify(date) {
  const k = metaKey(date);
  if (DATE_META[k]) return DATE_META[k];
  if (date.getDay() === 0) return { type: 'holiday', title: 'Sunday', note: 'Weekly off' };
  return { type: 'working', title: 'Working day', note: 'Regular schedule' };
}
function getPeriods(date) {
  const meta = classify(date);
  if (meta.type === 'holiday') return [];
  return STUDENT_TIMETABLE[date.getDay()] || [];
}
function periodCount(date) { return getPeriods(date).filter(p => !p.break).length; }
function toMins(t) { const [h, m] = t.split(':').map(Number); return h * 60 + m; }
function durText(t, end) {
  const m = toMins(end) - toMins(t);
  if (m >= 60) { const h = Math.floor(m / 60), mm = m % 60; return mm ? `${h}h ${mm}m` : `${h}h`; }
  return `${m}m`;
}
function totalClassTime(date) {
  let m = 0;
  getPeriods(date).filter(p => !p.break).forEach(p => { m += toMins(p.end) - toMins(p.t); });
  const h = Math.floor(m / 60), mm = m % 60;
  if (!m) return '0h';
  if (h && mm) return `${h}h ${mm}m`;
  return h ? `${h}h` : `${mm}m`;
}
function uniqueRooms(date) {
  return new Set(getPeriods(date).filter(p => !p.break).map(p => p.room)).size;
}
function getInitials(name) {
  return name.replace(/\(.*\)/g, '').split(/[\s.]+/).filter(Boolean).slice(-2).map(s => s[0]).join('').toUpperCase().slice(0, 2) || '··';
}
function nowState(date) {
  const today = new Date();
  if (!isSameDay(date, today)) return null;
  const nowMins = today.getHours() * 60 + today.getMinutes();
  const periods = getPeriods(date);
  for (let i = 0; i < periods.length; i++) {
    const p = periods[i];
    if (p.break) continue;
    const start = toMins(p.t), end = toMins(p.end);
    if (nowMins >= start && nowMins < end) {
      return { state: 'in', current: p, progress: (nowMins - start) / (end - start), minsLeft: end - nowMins };
    }
    if (nowMins < start) return { state: 'before', upcoming: p, minsUntil: start - nowMins };
  }
  return { state: 'after' };
}

// ─── Component ────────────────────────────────────────────────────────────────
class StudentCalendarSection extends Component {
  constructor(props) {
    super(props);
    const today = new Date();
    this.state = {
      today,
      selectedDate: today,
      calMonth: today.getMonth(),
      calYear: today.getFullYear(),
      liveClock: this._clock(),
      attendance: generateMockAttendance(today.getMonth(), today.getFullYear()),
    };
  }

  _clock() {
    const d = new Date();
    return `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
  }

  componentDidMount() {
    this._interval = setInterval(() => {
      this.setState({ liveClock: this._clock() });
      if (isSameDay(this.state.selectedDate, this.state.today)) this.forceUpdate();
    }, 30000);
  }

  componentWillUnmount() { clearInterval(this._interval); }

  selectDate = (d) => this.setState({ selectedDate: d });
  prevMonth = () => this.setState(s => {
    let m = s.calMonth - 1, y = s.calYear;
    if (m < 0) { m = 11; y--; }
    const att = generateMockAttendance(m, y);
    return { calMonth: m, calYear: y, attendance: att };
  });
  nextMonth = () => this.setState(s => {
    let m = s.calMonth + 1, y = s.calYear;
    if (m > 11) { m = 0; y++; }
    const att = generateMockAttendance(m, y);
    return { calMonth: m, calYear: y, attendance: att };
  });
  goToToday = () => {
    const t = new Date();
    this.setState({
      selectedDate: t,
      calMonth: t.getMonth(),
      calYear: t.getFullYear(),
      attendance: generateMockAttendance(t.getMonth(), t.getFullYear()),
    });
  };

  // ─── Mini calendar ────────────────────────────────────────────────────────────
  renderMiniCal() {
    const { calMonth, calYear, selectedDate, today, attendance } = this.state;
    const first = new Date(calYear, calMonth, 1);
    const last = new Date(calYear, calMonth + 1, 0);
    const lead = (first.getDay() + 6) % 7;

    const cells = [];
    for (let i = lead; i > 0; i--) cells.push({ date: new Date(calYear, calMonth, 1 - i), out: true });
    for (let d = 1; d <= last.getDate(); d++) cells.push({ date: new Date(calYear, calMonth, d), out: false });
    const need = (Math.ceil(cells.length / 7)) * 7 - cells.length;
    for (let i = 1; i <= need; i++) cells.push({ date: new Date(calYear, calMonth + 1, i), out: true });

    return (
      <div className="cal-panel">
        <div className="cal-panel-head">
          <span className="cal-panel-title">{MONTHS[calMonth]} <span className="year">{calYear}</span></span>
          <div className="cal-nav-btns">
            <button className="cal-icon-btn" onClick={this.prevMonth}>‹</button>
            <button className="cal-icon-btn" onClick={this.goToToday} title="Today">•</button>
            <button className="cal-icon-btn" onClick={this.nextMonth}>›</button>
          </div>
        </div>
        <div className="mini-cal-body">
          <div className="mini-dow-row">
            {['M','T','W','T','F','S','S'].map((d, i) => (
              <span key={i} className={i === 6 ? 'weekend' : ''}>{d}</span>
            ))}
          </div>
          <div className="mini-grid">
            {cells.map((cell, idx) => {
              if (cell.out) return <div key={idx} className="mday outside"><span className="mday-num">{cell.date.getDate()}</span></div>;
              const meta = classify(cell.date);
              const isT = isSameDay(cell.date, today);
              const isSel = isSameDay(cell.date, selectedDate);
              const pc = periodCount(cell.date);
              const attVal = attendance[cell.date.getDate()];
              let cls = 'mday';
              if (meta.type !== 'working') cls += ` ${meta.type}`;
              else if (attVal === 1) cls += ' event';
              else if (attVal === 0) cls += ' holiday';
              if (isT) cls += ' today';
              if (isSel) cls += ' selected';
              return (
                <div key={idx} className={cls} onClick={() => this.selectDate(cell.date)}>
                  <span className="mday-num">{cell.date.getDate()}</span>
                  {pc > 0 && <span className="mday-count">{pc}p</span>}
                  {meta.type !== 'working' && <span className="mday-dot" />}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  // ─── Attendance summary ───────────────────────────────────────────────────────
  renderAttendanceSummary() {
    const { attendance, calMonth, calYear } = this.state;
    const vals = Object.values(attendance);
    const total = vals.filter(v => v !== -1).length;
    const present = vals.filter(v => v === 1).length;
    const absent = vals.filter(v => v === 0).length;
    const pct = total > 0 ? Math.round((present / total) * 100) : 0;
    const isLow = pct < 75;

    return (
      <div className="stu-att-panel">
        <div className="stu-att-head">
          <span className="stu-att-title">
            Attendance — {MONTHS[calMonth]} {calYear}
          </span>
          <span style={{
            fontSize: 11, fontWeight: 700, padding: '3px 8px', borderRadius: 5,
            background: isLow ? '#fbeeea' : '#e8f3ec',
            color: isLow ? '#c0533a' : '#3d8a55',
            border: `1px solid ${isLow ? '#f3d2c8' : '#b8ddc8'}`,
          }}>
            {pct}%
          </span>
        </div>
        <div className="stu-att-stats">
          <div className="stu-att-stat present">
            <span className="stu-att-num">{present}</span>
            <span className="stu-att-lbl">Present</span>
          </div>
          <div className="stu-att-stat absent">
            <span className="stu-att-num">{absent}</span>
            <span className="stu-att-lbl">Absent</span>
          </div>
          <div className="stu-att-stat pct">
            <span className="stu-att-num">{pct}%</span>
            <span className="stu-att-lbl">Attendance</span>
          </div>
        </div>
        <div className="stu-att-bar-wrap">
          <div className="stu-att-bar-label">
            {isLow
              ? `⚠️ Attendance below 75% — ${Math.ceil((0.75 * total - present) / 0.25)} more days needed`
              : `✓ Attendance is healthy`}
          </div>
          <div className="stu-att-bar">
            <div className="stu-att-bar-fill" style={{ width: `${pct}%` }} />
          </div>
        </div>
      </div>
    );
  }

  // ─── Upcoming ─────────────────────────────────────────────────────────────────
  renderUpcoming() {
    const { today } = this.state;
    const items = [];
    for (let i = 0; i < 30; i++) {
      const d = new Date(today); d.setDate(d.getDate() + i);
      const k = metaKey(d);
      if (DATE_META[k]) items.push({ date: new Date(d), meta: DATE_META[k], days: i });
    }
    return (
      <div className="cal-panel">
        <div className="cal-panel-head">
          <span className="cal-panel-title">Upcoming</span>
          <span className="cal-panel-subtitle">Next 30 days</span>
        </div>
        {items.length === 0
          ? <div style={{ padding: '16px', fontSize: 12, color: '#71717a' }}>No upcoming events.</div>
          : (
            <div className="upcoming-list">
              {items.slice(0, 5).map((item, idx) => {
                const rel = item.days === 0 ? 'Today' : item.days === 1 ? 'Tomorrow' : `${item.days}d`;
                return (
                  <div
                    key={idx}
                    className={`upcoming-item ${item.meta.type}`}
                    onClick={() => this.setState({ selectedDate: item.date, calMonth: item.date.getMonth(), calYear: item.date.getFullYear() })}
                  >
                    <div className="up-date">
                      <span className="up-dnum">{item.date.getDate()}</span>
                      <span className="up-dmo">{MONTHS_SHORT[item.date.getMonth()]}</span>
                    </div>
                    <div className="up-info">
                      <div className="up-title">{item.meta.title}</div>
                      <div className="up-sub">{item.meta.note}</div>
                    </div>
                    <span className="up-rel">{rel}</span>
                  </div>
                );
              })}
            </div>
          )
        }
      </div>
    );
  }

  // ─── Now strip ────────────────────────────────────────────────────────────────
  renderNowStrip(ns, meta, isToday) {
    if (!isToday) {
      return (
        <div className="now-strip idle">
          <div className="now-icon idle"><i className="fal fa-calendar-day" /></div>
          <div className="now-text">
            <div className="now-label idle">Schedule</div>
            <div className="now-name">{DAYS[this.state.selectedDate.getDay()]} Timetable</div>
            <div className="now-meta">{moment(this.state.selectedDate).format('DD MMM YYYY')}</div>
          </div>
        </div>
      );
    }
    if (meta.type === 'holiday') {
      return (
        <div className="now-strip idle">
          <div className="now-icon idle"><i className="fal fa-umbrella-beach" /></div>
          <div className="now-text">
            <div className="now-label idle">Holiday</div>
            <div className="now-name">{meta.title}</div>
            <div className="now-meta">{meta.note}</div>
          </div>
        </div>
      );
    }
    if (!ns || ns.state === 'after') {
      return (
        <div className="now-strip idle">
          <div className="now-icon idle"><i className="fal fa-check-circle" /></div>
          <div className="now-text">
            <div className="now-label idle">Day complete</div>
            <div className="now-name">All classes done for today</div>
            <div className="now-meta">See you tomorrow!</div>
          </div>
          <div className="now-clock">{this.state.liveClock}</div>
        </div>
      );
    }
    if (ns.state === 'before') {
      const m = ns.minsUntil;
      return (
        <div className="now-strip idle">
          <div className="now-icon idle"><i className="fal fa-clock" /></div>
          <div className="now-text">
            <div className="now-label idle">Up next</div>
            <div className="now-name">{ns.upcoming.subject}</div>
            <div className="now-meta">{ns.upcoming.teacher} · {ns.upcoming.room}</div>
          </div>
          <div className="now-time-wrap">
            <div className="now-time-val">{ns.upcoming.t}</div>
            <div className="now-time-sub">{m < 60 ? `in ${m}m` : `in ${Math.floor(m / 60)}h ${m % 60}m`}</div>
          </div>
        </div>
      );
    }
    const pct = Math.round(ns.progress * 100);
    return (
      <div className="now-strip active">
        <div className="now-icon active"><i className="fal fa-bolt" /></div>
        <div className="now-text">
          <div className="now-label active"><span className="now-dot" />In Progress</div>
          <div className="now-name">{ns.current.subject}</div>
          <div className="now-meta">{ns.current.teacher} · {ns.current.room} · {ns.current.code}</div>
        </div>
        <div className="now-time-wrap">
          <div className="now-time-val">Ends {ns.current.end}</div>
          <div className="now-time-sub">{pct}% done · {ns.minsLeft}m left</div>
        </div>
        <div className="now-progress-bar">
          <div className="now-progress-fill" style={{ width: `${pct}%` }} />
        </div>
      </div>
    );
  }

  // ─── Period list (read-only for students) ─────────────────────────────────────
  renderPeriods() {
    const { selectedDate, today } = this.state;
    const periods = getPeriods(selectedDate);
    const meta = classify(selectedDate);
    const isToday = isSameDay(selectedDate, today);
    const nowMins = new Date().getHours() * 60 + new Date().getMinutes();

    if (meta.type === 'holiday') {
      return (
        <div className="empty-state">
          <div className="empty-icon"><i className="fal fa-calendar-times" /></div>
          <h5>{meta.title}</h5>
          <p>{meta.note}</p>
        </div>
      );
    }
    if (periods.length === 0) {
      return (
        <div className="empty-state">
          <div className="empty-icon"><i className="fal fa-calendar" /></div>
          <h5>No classes</h5>
          <p>No schedule for this day</p>
        </div>
      );
    }

    let pn = 0;
    return (
      <div className="period-list">
        {periods.map((p, idx) => {
          if (p.break) {
            return (
              <div key={idx} className="period break">
                <div className="p-time-col"><span className="p-start">{p.t} – {p.end}</span></div>
                <div className="p-info"><span className="break-title">{p.title}</span></div>
              </div>
            );
          }
          pn++;
          const start = toMins(p.t), end = toMins(p.end);
          const isNow = isToday && nowMins >= start && nowMins < end;
          const isPast = isToday && nowMins >= end;
          let cls = 'period';
          if (isNow) cls += ' now-period';
          else if (isPast) cls += ' past-period';

          return (
            <div key={idx} className={cls}>
              <div className="p-time-col">
                <span className="p-start">{p.t}</span>
                <span className="p-end">– {p.end}</span>
                <span className="p-dur">{durText(p.t, p.end)}</span>
              </div>
              <div className="p-avatar">{getInitials(p.teacher)}</div>
              <div className="p-info">
                <div className="p-title-row">
                  <span className="p-num">P{pn}</span>
                  <span className="p-title">{p.subject}</span>
                  {isNow && <span className="live-badge">Live</span>}
                </div>
                <div className="p-meta-row">
                  <span className="p-code">{p.code}</span>
                  <span className="p-sep">·</span>
                  <span className="p-teacher">{p.teacher}</span>
                </div>
              </div>
              <div className="p-actions">
                <div className="p-room">
                  <i className="fal fa-map-marker-alt" style={{ marginRight: 4, fontSize: 10 }} />{p.room}
                </div>
                {isPast && (
                  <span style={{
                    fontSize: 10, fontWeight: 700, color: '#a0a0ac',
                    background: '#f4f5f8', border: '1px solid #e8e9ef',
                    borderRadius: 4, padding: '2px 7px', fontFamily: 'monospace',
                    textTransform: 'uppercase', letterSpacing: '0.06em',
                  }}>Done</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  // ─── Main render ──────────────────────────────────────────────────────────────
  render() {
    const { selectedDate, today, liveClock } = this.state;
    const meta = classify(selectedDate);
    const isToday = isSameDay(selectedDate, today);
    const ns = nowState(selectedDate);
    const pc = periodCount(selectedDate);

    let heroTitle = DAYS[selectedDate.getDay()];
    if (isToday) heroTitle = 'Today';
    else if (isSameDay(selectedDate, new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1))) heroTitle = 'Tomorrow';
    else if (isSameDay(selectedDate, new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1))) heroTitle = 'Yesterday';

    return (
      <div className="cal-wrap">
        {/* Page header */}
        <div className="cal-page-header">
          <div>
            <h4 className="cal-page-title">My Schedule</h4>
            <p className="cal-page-sub">View your timetable, attendance &amp; upcoming events</p>
          </div>
          <div className="cal-header-actions">
            <div className="cal-live-pill">
              <span className="live-dot" />
              {liveClock}
            </div>
            <button className="cal-outline-btn" onClick={this.goToToday}>
              <i className="fal fa-crosshairs" style={{ marginRight: 5 }} />Today
            </button>
          </div>
        </div>

        <Row style={{ marginLeft: 0, marginRight: 0 }}>
          {/* Left: schedule */}
          <Col xl={8} lg={7} md={12} style={{ paddingLeft: 0, paddingRight: 8 }}>
            <div className="cal-hero">
              <div className="hero-head">
                <div>
                  <div className="hero-title-row">
                    <h3 className="hero-title">{heroTitle}</h3>
                    <span className={`cal-badge ${meta.type}`}>{meta.title}</span>
                  </div>
                  <div className="hero-sub">
                    {DAYS[selectedDate.getDay()]} · {selectedDate.getDate()} {MONTHS[selectedDate.getMonth()]} {selectedDate.getFullYear()}
                  </div>
                </div>
                <div className="hero-stats">
                  <div className="hstat">
                    <span className="hstat-v">{pc}</span>
                    <span className="hstat-l">Periods</span>
                  </div>
                  <div className="hstat">
                    <span className="hstat-v">{totalClassTime(selectedDate)}</span>
                    <span className="hstat-l">Class time</span>
                  </div>
                  <div className="hstat">
                    <span className="hstat-v">{uniqueRooms(selectedDate)}</span>
                    <span className="hstat-l">Locations</span>
                  </div>
                </div>
              </div>
              {this.renderNowStrip(ns, meta, isToday)}
              {this.renderPeriods()}
            </div>
          </Col>

          {/* Right: mini cal + attendance + upcoming */}
          <Col xl={4} lg={5} md={12} style={{ paddingLeft: 8, paddingRight: 0 }}>
            <div className="cal-side">
              {this.renderMiniCal()}
              {this.renderAttendanceSummary()}
              {this.renderUpcoming()}
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default StudentCalendarSection;
